/* ==========================================================================
   NOOBDE Kids — behaviour
   Vanilla ES2015+. No jQuery, no dependencies, loaded with `defer`.
   Only two jobs: horizontal scroller controls, and an optional scroll reveal.
   The FAQ uses native <details>/<summary>, so it needs no JavaScript at all.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initScroller(root) {
    if (root.dataset.nkScrollerReady === 'true') return;

    var track = root.querySelector('[data-nk-scroller-track]');
    var prev = root.querySelector('[data-nk-scroller-prev]');
    var next = root.querySelector('[data-nk-scroller-next]');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function scrollBy(direction) {
      track.scrollBy({
        left: step() * direction,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    function syncButtons() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    track.addEventListener('scroll', syncButtons, { passive: true });
    window.addEventListener('resize', syncButtons, { passive: true });
    syncButtons();

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); scrollBy(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); scrollBy(-1); }
    });

    root.dataset.nkScrollerReady = 'true';
  }

  function initReveal(scope) {
    var targets = (scope || document).querySelectorAll('.nk-reveal:not(.is-in)');
    if (!targets.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(targets, function (el, index) {
      el.style.transitionDelay = Math.min(index % 6, 5) * 60 + 'ms';
      observer.observe(el);
    });
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-nk-scroller]'), initScroller);
    initReveal(root);
  }

  document.documentElement.classList.remove('no-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) { init(event.target); });
})();
